
import React, { useState, useEffect, useRef, useCallback } from "react";
import cn from "classnames";
import styles from "../../screen/sites/Site.module.scss";
import StatusComponent from "../StatusComponent";
import Energy from "../echarts/Energy";
import Swapping from "../echarts/Swapping";
import Revenue from "../echarts/Revenue";
import Soc from "../echarts/Soc";
import Fault from "../echarts/Fault";
import Master from "screen/Master";
import { getRequest, postRequest } from "../../services/axiosBaseClient";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import LocalStorageService from "services/tokenlocalstorage.service";
import { duration } from "@material-ui/core";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";
import { logDOM } from "@testing-library/react";
let multiselectArray = [];

export default function SiteAnalytic(props) {
  const filterInitialValue = {
    siteId: props.siteId,
    state: "",
    city: "",
    zoneId: "",
    startDate: parseInt(Date.now() / 1000) - 86400,
    endDate: parseInt(Date.now() / 1000),
    time: "HOUR_24",
    cityId: "",
    stateId: "",
    swapStationId: "",
    timeFilterEnum: "HOUR_24",
  };

  const siteId = props.siteId;
  const [open, setOpen] = React.useState(false);
  const [batteriesSwap, getBatteriesSwap] = useState("");
  const [swap, getSwap] = useState("");
  const [alert, getAlert] = useState("");
  const refOpen = useRef(open);
  const [sitesList, setSitesList] = useState([]);
  const [chargerList, setChargerList] = useState([]);
  const [selectTimeValue, setSelectTimeValue] = useState("HOUR_24");
  const [loadingEnergy, setLoadingEnergy] = useState("true");
  const [loadingSwapping, setLoadingSwapping] = useState("true");
  const [loadingFault, setLoadingFault] = useState("true");
  const [loadingRevenue, setLoadingRevenue] = useState("true");
  const [loadingSOC, setLoadingSOC] = useState("true");

  const [filter, setFilter] = useState(filterInitialValue);

  function useOutsideAlerter(ref, ref1) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          refOpen.current = false;
        } else {
          if (
            refOpen.current &&
            ref1.current &&
            !ref1.current.contains(event.target)
          ) {
            refOpen.current = false;
            setOpen(false);
          } else {
            setOpen(true);
            refOpen.current = true;
          }
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, ref1]);
  }

  const wrapperRef = useRef(null);
  const wrapperRefInside = useRef(null);

  useOutsideAlerter(wrapperRef, wrapperRefInside);

  // const handleClickApply = () => {
  //   setOpen(!open);
  //   updateGraphData();

  // };

  // const handleClickCancel = () => {
  //   setOpen(!open);
  // };

  const handleClickApply = (btnType) => {
    if (open) {
      if (btnType == "reset") {
        setLoadingEnergy("true");
        setLoadingSwapping("true");
        setLoadingFault("true");
        setLoadingRevenue("true");
        setLoadingSOC("true");
        filter.time = filterInitialValue.time;
        filter.startDate = filterInitialValue.startDate;
        filter.endDate = filterInitialValue.endDate;
        filter.siteId = filterInitialValue.siteId;
        filter.swapStationId = "";
        setSelectTimeValue(filterInitialValue.time);
        updateGraphData(filter);
        setChargerList([])
      } else {
        /* const headerFilterObj = JSON.parse(
          LocalStorageService.get("headerFilter")
        );
        if (
          headerFilterObj?.stateId !== undefined &&
          headerFilterObj?.stateId !== ""
        ) {
          setFilter({ ...filter, stateId: headerFilterObj.stateId });
        }

        if (
          headerFilterObj?.cityId !== undefined &&
          headerFilterObj?.cityId !== ""
        ) {
          setFilter({ ...filter, cityId: headerFilterObj.cityId });
        }

        if (
          headerFilterObj?.zoneId !== undefined &&
          headerFilterObj?.zoneId !== ""
        ) {
          setFilter({ ...filter, zoneId: headerFilterObj.zoneId });
        }*/
        setLoadingEnergy("true");
        setLoadingSwapping("true");
        setLoadingFault("true");
        setLoadingRevenue("true");
        setLoadingSOC("true");
        setSelectTimeValue(selectTime);
        updateGraphData(filter);
      }
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const [swappingVal, setSwappingVal] = useState([]);
  const [energyData, setEnergyData] = useState([]);
  const [selectTime, setSelectTime] = useState(24);
  const [revenueData, setRevenueData] = useState();
  const [socData, setSocData] = useState([]);
  const [swapStationData, setSwapSationData] = useState([]);

  const getSwapStatus = useCallback(async () => {
    await postRequest("bss/getSwappedStationStatus", {
      cityId: filter.cityId,
      siteId: filter.siteId,
      stateId: filter.stateId,
      swapStationId: filter.swapStationId,
      timeFilterEnum: filter.timeFilterEnum,
      zoneId: filter.zoneId,
    })
      .then((res) => {
        if (res && res?.data) {
          getSwap(res.data);
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, []);

  const getAlertSatus = useCallback(async () => {
    const postdata = {
      state: "string",
      city: "string",
      zoneId: 0,
      siteId: props.siteId,
      chargerId: 0,
      time: "HOUR_24",
    };

    await getRequest(
      "bss/getAlertDetails?siteId=" + (siteId === undefined ? 0 : siteId),
      filter
    )
      .then((res) => {
        if (res && res?.data) {
          getAlert(res.data);
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, []);

  const getBatteryStatus = useCallback(async () => {
    await postRequest("bss/getBatteriesStatusInSwappedStation", {
      stateId: filter.stateId,
      cityId: filter?.cityId,
      zoneId: filter?.zoneId,
      siteId: filter?.siteId,
      timeFilterEnum: filter.time,
      swapStationId: filter.swapStationId,
    })
      .then((res) => {
        if (res && res?.data) {
          getBatteriesSwap(res.data);
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, []);

  const getSwappingVal = useCallback(async (filter) => {
    await postRequest(`bss/dashboard/swappingCountGraph`, {
      cityId: filter.cityId,
      siteId: filter.siteId,
      stateId: filter.stateId,
      swapStationId: filter.swapStationId,
      timeFilterEnum: filter.time,
      zoneId: filter.zoneId,
    })
      .then((res) => {
        if (res && res?.data) {
          setSwappingVal(res?.data);
          setLoadingSwapping("false");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, []);
  // console.log("------+++----", swappingVal);
  // useEffect(() => {
  //   const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
  //   if (headerFilterObj !== null) {
  //     filter.state = headerFilterObj.state;
  //     filter.city = headerFilterObj.city;
  //     filter.zoneId = headerFilterObj.zoneId;
  //   }
  //   getSwapStatus();
  //   getBatteryStatus();
  //   getAlertSatus();
  //   getSwappingVal(filter);
  // }, []);

  const getRevenueData = useCallback(async (filter) => {
    await postRequest(`bss/getRevenue`, {
      cityId: filter.cityId,
      siteId: filter.siteId,
      stateId: filter.stateId,
      swapStationId: filter.swapStationId,
      timeFilterEnum: filter.time,
      zoneId: filter.zoneId,
    })
      .then((res) => {
        if (res && res?.data) {
          setRevenueData(res.data);
          setLoadingRevenue("false");
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getEnergyData = useCallback(
    async (id, startDate, endDate, swapStationId) => {
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      var query =
        (filter?.siteId === undefined || filter?.siteId === ""
          ? ""
          : "&siteId=" + filter.siteId) +
        (swapStationId === undefined || swapStationId === ""
          ? ""
          : "&chargerId=" + swapStationId) +
        (filter?.timeFilterEnum === undefined || filter?.timeFilterEnum === ""
          ? ""
          : "&timeFilterEnum=" + filter.timeFilterEnum) +
        (headerFilterObj?.stateId === undefined ||
          headerFilterObj?.stateId === ""
          ? ""
          : "&stateId=" + headerFilterObj.stateId) +
        (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
          ? ""
          : "&cityId=" + headerFilterObj.cityId) +
        (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
          ? ""
          : "&zoneId=" + headerFilterObj.zoneId);
      await getRequest(
        `bss/getBatteryEnergyDetails?&startDate=${startDate}&endDate=${endDate}&` +
        query
      )
        .then((res) => {
          if (res && res?.data) {
            setEnergyData(res?.data);
            setLoadingEnergy("false");
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    },
    []
  );

  const getSocData = useCallback(
    async (id, startDate, endDate, swapStationId) => {
      // cityId: filter.cityId,
      //   siteId: filter.siteId,
      //   stateId: filter.stateId,
      //   swapStationId: filter.swapStationId,
      //   timeFilterEnum: filter.timeFilterEnum,
      //   zoneId: filter.zoneId,
      //   swapStationId: filter.swapStationId,
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      var query =
        (filter?.siteId === undefined || filter?.siteId === ""
          ? ""
          : "&siteId=" + filter.siteId) +
        (filter?.swapStationId === undefined || filter?.swapStationId === ""
          ? ""
          : "&swapStationId=" + filter.swapStationId) +
        (filter?.timeFilterEnum === undefined || filter?.timeFilterEnum === ""
          ? ""
          : "&timeFilterEnum=" + filter.timeFilterEnum) +
        (headerFilterObj?.stateId === undefined ||
          headerFilterObj?.stateId === ""
          ? ""
          : "&stateId=" + headerFilterObj.stateId) +
        (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
          ? ""
          : "&cityId=" + headerFilterObj.cityId) +
        (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
          ? ""
          : "&zoneId=" + headerFilterObj.zoneId);
      await getRequest(
        `bss/getSOC?startDate=${startDate}&endDate=${endDate}&swapStationId=${swapStationId}` +
        query
      )
        .then((res) => {
          if (res && res?.data) {
            setSocData(res?.data);
            setLoadingSOC("false");
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    },
    []
  );

  const getSites = useCallback(async () => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    await getRequestInAssets("bss/site/siteList")
      .then((res) => {
        if (res.data != null) {
          setSitesList(res?.data.filter((x) => x.id == props.siteId));
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getSwapstationFaultData = useCallback(async (filter) => {
    await postRequest(`bss/dashboard/swapStationFaultGraph`, {
      cityId: filter.cityId,
      siteId: filter.siteId,
      stateId: filter.stateId,
      swapStationId: filter.swapStationId,
      timeFilterEnum: filter.time,
      zoneId: filter.zoneId,
    })
      .then((res) => {
        if (res && res?.data) {
          setSwapSationData(res?.data);
          setLoadingFault("false");
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    if (headerFilterObj !== null) {
      filter.stateId = headerFilterObj.stateId;
      filter.cityId = headerFilterObj.cityId;
      filter.zoneId = headerFilterObj.zoneId;
    }
    getSites();
    getChargers(filter.siteId);
    getSwapStatus();
    getBatteryStatus();
    getAlertSatus();
    getEnergyData(
      filter.siteId,
      filter.startDate,
      filter.endDate,
      filter.swapStationId
    );
    getSwappingVal(filter);
    getRevenueData(filter);
    getSwapstationFaultData(filter);
    getSocData(
      filter.siteId,
      filter.startDate,
      filter.endDate,
      filter.swapStationId
    );
  }, []);

  function updateGraphData(filter) {
    getSwapstationFaultData(filter);
    getSwappingVal(filter);
    getEnergyData(
      filter.siteId,
      filter.startDate,
      filter.endDate,
      filter.swapStationId
    );
    getRevenueData(filter);
    getSocData(siteId, filter.startDate, filter.endDate, filter.swapStationId);
  }

  // const chartVal = [
  //   { LabelVal: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] },
  //   { energyVal: [100, 410, 100, 350, 200, 280, 100] },
  //   { swappingVal: [100, 410, 100, 350, 200, 280, 100] },
  //   { faultVal: [100, 210, 110, 300, 270, 290, 200] },
  //   { revenueVal: [0, 200, 100, 300, 100, 440, 100] },
  // ];
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });
    if (
      event.target.name === "time" ||
      event.target.name === "timeFilterEnum"
    ) {
      setSelectTime(event.target.value);

      if (value === "HOUR_12") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 43200,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
      }
      if (value === "HOUR_24") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
      }
      if (value === "WEEK") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 604800,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
      }
      if (value === "WEEK_2") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 1209600,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
      }
      if (value === "MONTH") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 2592000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
      }
      if (value === "MONTH_3") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 7776000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
      }
    }
    if (event.target.name == "siteId") {
      setFilter({ ...filter, [name]: value, swapStationId: "" });
      getChargers(event.target.value);
    }
  };
  const getChargers = useCallback(async (siteId) => {
    await getRequestInAssets(
      `bss/swappingStation/getAllSwappingStationsBySite?siteId=${siteId}`
    )
      .then((res) => {
        if (res.data != null) {
          setChargerList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const arrayData = [
    {
      //ic_background:'yellow',
      ic_background: "#fcc644ff",
      ic: require("assets/charger-status.png").default,
      title: "Swap Station",
      progress1name: "Healthy",
      progress2name: "Fault",
      progress3name: "Under Maintenence",
      progress1percent: swap.healthy,
      progress2percent: swap.fault,
      progress3percent: swap.underMaintainance,
    },
    {
      ic_background: "green",
      ic: require("assets/battery1.png").default,
      title: "Batteries in Swap Station",
      progress1name: "Charged",
      progress2name: "Charging",
      progress3name: "Fault",
      progress1percent: batteriesSwap.charged,
      progress2percent: batteriesSwap.charging,
      progress3percent: batteriesSwap.fault,
    },
    {
      ic_background: "#E3324C",
      ic: require("assets/alert.svg").default,
      title: "Alerts",
      progress1name: "Temperature",
      progress2name: "Upcoming Swapping",
      progress3name: "Alerts",
      progress1percent: alert.temperature === null ? 0 : alert.temperature,
      progress2percent: alert.upcomingSwaps === null ? 0 : alert.upcomingSwaps,
      progress3percent: alert.alerts === null ? 0 : alert.alerts,
    },
  ];
  return (
    <>
      <div className={cn(styles.body_flex_item3)}>
        <div className={cn(styles.status_flex, styles.status_flex_layout)}>
          <div className={cn(styles.status_flex_item)}>
            <div
              className={cn(styles.status_block, styles.status_block_layout)}
            >
              <div className={cn(styles.component, styles.component_layout)}>
                <StatusComponent
                  ic_background={arrayData[0].ic_background}
                  ic={arrayData[0].ic}
                  progress1color={'green'}
                  progress2color={'red'}
                  progress3color={'#FFBF00'}
                  progress1name={arrayData[0].progress1name}
                  progress2name={arrayData[0].progress2name}
                  progress3name={arrayData[0].progress3name}
                  progress1percent={arrayData[0].progress1percent}
                  progress2percent={arrayData[0].progress2percent}
                  progress3percent={arrayData[0].progress3percent}
                  header={arrayData[0].title}
                />
              </div>
            </div>
          </div>
          <div className={cn(styles.flex4_spacer1)} />
          <div className={cn(styles.block46_item)}>
            <div
              className={cn(styles.status_block, styles.status_block_layout)}
            >
              <StatusComponent
                ic_background={arrayData[1].ic_background}
                ic={arrayData[1].ic}
                progress1color={'green'}
                progress2color={'#FFBF00'}
                progress3color={'red'}
                progress1name={arrayData[1].progress1name}
                progress2name={arrayData[1].progress2name}
                progress3name={arrayData[1].progress3name}
                progress1percent={arrayData[1].progress1percent}
                progress2percent={arrayData[1].progress2percent}
                progress3percent={arrayData[1].progress3percent}
                header={arrayData[1].title}
              />
            </div>
          </div>
          <div className={cn(styles.block46_spacer)} />
          <div className={cn(styles.block46_item)}>
            <div
              className={cn(styles.status_block, styles.status_block_layout)}
            >
              <StatusComponent
                ic_background={arrayData[2].ic_background}
                ic={arrayData[2].ic}
                progress1name={arrayData[2].progress1name}
                progress2name={arrayData[2].progress2name}
                progress3name={arrayData[2].progress3name}
                progress1percent={arrayData[2].progress1percent}
                progress2percent={arrayData[2].progress2percent}
                progress3percent={arrayData[2].progress3percent}
                header={arrayData[2].title}
              />
            </div>
          </div>
        </div>
        <hr className={cn(styles.line1, styles.line1_layout)} />
        <div
          ref={wrapperRef}
          style={{ cursor: "pointer" }}
          className={cn(
            styles.graph_filter_block,
            styles.graph_filter_block_layout
          )}
        >
          <div
            className={cn(
              styles.graph_filter_text_block,
              styles.graph_filter_text_block_layout
            )}
          >
            <div className={cn(styles.text_body, styles.text_body_layout)}>
              {"Filters"}
            </div>
          </div>

          <div className={cn(styles.box16, styles.box16_layout)}>
            <img
              src={require("assets/Vector.svg").default}
              className={cn(styles.box1, styles.box1_layout)}
            />
            <div>
              {open && (
                <div id="filter" open={open} ref={wrapperRefInside}>
                  <div
                    className={cn(
                      styles.status1_block,
                      styles.status1_block_layout
                    )}
                  >
                    <div>
                      <select
                        style={{ width: "80%", height: "35px" }}
                        name="time"
                        id="time"
                        onChange={handleChange}
                        value={filter.time}
                      >
                        <option value="" disabled selected>
                          Select Time Period
                        </option>
                        <option value="HOUR_24" selected>
                          Last 24 hours
                        </option>
                        <option value="HOUR_12">Last 12 hours</option>
                        <option value="WEEK">Last 1 week</option>
                        <option value="WEEK_2">Last 2 weeks</option>
                        <option value="MONTH">Last 1 month</option>
                        <option value="MONTH_3">Last 3 months</option>
                      </select>
                    </div>

                    <div>
                      <select
                        style={{ width: "80%", height: "35px" }}
                        name="siteId"
                        id="siteId"
                        onChange={handleChange}
                        value={filter.siteId}
                      >
                        <option value="" disabled selected>
                          Select Site
                        </option>
                        {sitesList.map((obj) => {
                          return <option value={obj.id}>{obj.name}</option>;
                        })}
                      </select>
                    </div>

                    <div>
                      <select
                        style={{ width: "80%", height: "35px" }}
                        name="swapStationId"
                        id="swapStationId"
                        onChange={handleChange}
                        value={filter.swapStationId}
                      >
                        <option value="" selected>
                          Select Swap Station
                        </option>
                        {chargerList.map((obj) => {
                          return <option value={obj.id}>{obj.name}</option>;
                        })}
                      </select>
                    </div>

                    <div>
                      <Button
                        style={{
                          background: "#E3324C",
                          color: "white",
                          margin: "15px 0px 6px 35px",
                          width: "85px",
                          height: "28px",
                        }}
                        onClick={() => {
                          handleClickApply("reset");
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        style={{
                          background: "#23297A",
                          color: "white",
                          margin: "15px 0px 6px 20px",
                          width: "85px",
                          height: "28px",
                        }}
                        onClick={() => {
                          handleClickApply("submit");
                        }}
                      >
                        Apply
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className={cn(
            styles.upper_graph_flex,
            styles.upper_graph_flex_layout
          )}
        >
          <div className={cn(styles.upper_graph_flex_item)}>
            <div
              className={cn(
                styles.graph_card_view,
                styles.graph_card_view_layout
              )}
            >
              <div className={cn(styles.block17, styles.block17_layout)}>
                <h5
                  className={cn(styles.highlights1, styles.highlights1_layout)}
                >
                  {"Energy"}
                </h5>

                <Energy
                  name={"bar"}
                  loading={loadingEnergy}
                  selectValue={selectTimeValue}
                  data={energyData}
                  styles={{
                    width: "100%",
                    height: "100%",
                    overflow: "visible",
                  }}
                />
                <h5
                  className={cn(
                    styles.highlights2,
                    styles.bottomTitle,
                    styles.highlights1_layout
                  )}
                >
                  {"Time"}
                </h5>
              </div>
            </div>
          </div>
          <div className={cn(styles.upper_graph_flex_spacer)} />
          <div className={cn(styles.upper_graph_flex_item)}>
            <div
              className={cn(
                styles.graph_card_view,
                styles.graph_card_view_layout
              )}
            >
              <div className={cn(styles.block17, styles.block17_layout)}>
                <h5
                  className={cn(styles.highlights1, styles.highlights1_layout)}
                >
                  {"Swapping"}
                </h5>
                <Swapping
                  loading={loadingSwapping}
                  selectValue={selectTimeValue}
                  data={swappingVal}
                  styles={{ with: "100%", height: "100%" }}
                />
                <h5
                  className={cn(
                    styles.highlights2,
                    styles.bottomTitle,
                    styles.highlights1_layout
                  )}
                >
                  {"Time"}
                </h5>
              </div>
            </div>
          </div>
          <div className={cn(styles.upper_graph_flex_spacer)} />
          <div className={cn(styles.upper_graph_flex_item)}>
            <div
              className={cn(
                styles.graph_card_view,
                styles.graph_card_view_layout1
              )}
            >
              <div className={cn(styles.block17, styles.block17_layout)}>
                <h5
                  className={cn(styles.highlights1, styles.highlights1_layout)}
                >
                  {"Swap Station Fault"}
                </h5>

                <Fault
                  loading={loadingFault}
                  selectValue={selectTimeValue}
                  dataVal={swapStationData}
                  styles={{ with: "100%", height: "100%" }}
                />
                <h5
                  className={cn(
                    styles.highlights2,
                    styles.bottomTitle,
                    styles.highlights1_layout
                  )}
                >
                  {"Time"}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div
          className={cn(
            styles.lower_graph_flex,
            styles.lower_graph_flex_layout
          )}
        >
          <div className={cn(styles.lower_graph_flex_item)}>
            <div
              className={cn(
                styles.graph_card_view,
                styles.graph_card_view_layout2
              )}
            >
              <div className={cn(styles.block17, styles.block17_layout)}>
                <h5
                  className={cn(styles.highlights1, styles.highlights1_layout)}
                >
                  {"Revenue"}
                </h5>

                <Revenue
                  loading={loadingRevenue}
                  selectValue={selectTimeValue}
                  data={revenueData}
                  styles={{ with: "100%", height: "100%" }}
                />
                <h5
                  className={cn(
                    styles.highlights2,
                    styles.bottomTitle,
                    styles.highlights1_layout
                  )}
                >
                  {"Time"}
                </h5>
              </div>
            </div>
          </div>
          <div className={cn(styles.lower_graph_flex_spacer)} />
          <div className={cn(styles.lower_graph_flex_item)}>
            <div
              className={cn(
                styles.graph_card_view,
                styles.graph_card_view_layout3
              )}
            >
              <div className={cn(styles.block17, styles.block17_layout)}>
                <h5
                  className={cn(styles.highlights1, styles.highlights1_layout)}
                >
                  {"SOC"}
                </h5>

                <Soc
                  selectValue={selectTimeValue}
                  data={socData}
                  loading={loadingSOC}
                  styles={{ with: "100%", height: "100%" }}
                />
                <h5
                  className={cn(
                    styles.highlights2,
                    styles.bottomTitle,
                    styles.highlights1_layout
                  )}
                >
                  {"Time"}
                </h5>
              </div>
            </div>
          </div>
          <div className={cn(styles.lower_graph_flex_spacer)} />
          <div className={cn(styles.lower_graph_flex_item)}></div>
        </div>
      </div>
    </>
  );
}

function SiteAnalytics(props) {
  return (
    <>
      <Master opts={props} screen={SiteAnalytic} showStatus={true} />
    </>
  );
}

SiteAnalytics.inStorybook = true;
